import { Navigate } from "react-router-dom";

import { resolveLandingPath } from "@/app/auth/resolveNavAccess";
import { useNavContext } from "@/app/auth/useNavContext";
import { FullScreenLoader } from "@/shared/components/FullScreenLoader";
import { NoNavigationAccessView } from "@/shared/components/NoNavigationAccessView";

/**
 * The `/app/*` catch-all and `/app/dashboard`.
 *
 * It used to redirect unconditionally to `/app/wallets`, which was fine while every route was open and
 * becomes a trap now that routes are gated: a user without `payments:read` would be bounced to a screen they
 * cannot open. Resolving the destination from the navigation registry guarantees the target is one this user
 * can actually see, and `null` — nothing visible at all — renders an explicit notice instead of ping-ponging
 * between guarded routes.
 *
 * That notice is `NoNavigationAccessView`, not `NoAccessView`: "you lack permission for this section" is the
 * wrong sentence for someone who asked for nothing in particular and can reach nothing at all.
 */
export const DashboardLandingRedirect = () => {
  const navContext = useNavContext();

  if (!navContext) return <FullScreenLoader />;

  const landingPath = resolveLandingPath(navContext);
  if (!landingPath) return <NoNavigationAccessView />;

  return <Navigate to={landingPath} replace />;
};
